import { useQuery } from '@tanstack/react-query';
import { getEbhRecommender } from '../..';

interface RecommenderDataParams {
  payload: {
    pageType: string;
    collectionType: string;
    groupId?: string | null;
  };

  enabled?: boolean;
}

const useGetRecommenderData = ({
  payload: { pageType, collectionType, groupId },
  enabled,
}: RecommenderDataParams) => {
  const payload = {
    pageType,
    collectionType,
    ...(groupId && {
      headers: {
        'x-groupid': groupId,
        'x-source': 'vidal',
      },
    }),
  };

  const {
    data: recommenderData,
    isLoading: isRecommenderLoading,
    isSuccess: isRecommenderSuccess,
    refetch: refetchRecommenderData,
  } = useQuery({
    queryKey: ['recommender-data', payload],
    queryFn: () => getEbhRecommender(payload),
    enabled: !!payload.pageType && !!payload.collectionType && enabled,
  });

  return {
    recommenderData,
    isRecommenderLoading,
    isRecommenderSuccess,
    refetchRecommenderData,
  };
};

export default useGetRecommenderData;
